import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { DownloadOutlined } from "@ant-design/icons";
import { useToast } from "../../../contexts/ToastContext";
import useBookingQrCode from "./useBookingQrCode";

const QrCodePanel = ({ url }) => {
    const { t } = useTranslation("shareGrow");
    const toast = useToast();
    const qrDataUrl = useBookingQrCode(url);

    const handleDownload = () => {
        if (!qrDataUrl) return;

        const link = document.createElement("a");
        link.href = qrDataUrl;
        link.download = "softcar-booking-qr.png";
        link.click();

        toast.success({ message: t("qrDownloaded") });
    };

    return (
        <div className="rounded-2xl border border-[#D7D6FE] bg-[#F2F1FE] p-4 shadow-sm sm:p-5">
            <h3 className="text-left text-base font-semibold text-gray-900">{t("qrCode")}</h3>
            <p className="mt-1 text-left text-sm text-gray-500">{t("qrCodeDescription")}</p>

            <div className="my-4 flex justify-center">
                {qrDataUrl ? (
                    <img src={qrDataUrl} alt={t("qrCode")} className="h-40 w-40 rounded-lg bg-white p-2" />
                ) : (
                    <div className="h-40 w-40 animate-pulse rounded-lg bg-white/70" />
                )}
            </div>

            <button
                type="button"
                onClick={handleDownload}
                disabled={!qrDataUrl}
                className="flex w-full items-center justify-center gap-3 rounded-xl border border-gray-200 bg-white py-2.5 text-sm font-semibold text-[#5D5DF6] transition-colors hover:bg-[#F0F0FE] disabled:cursor-not-allowed disabled:opacity-50">
                <DownloadOutlined /> {t("downloadQrPng")}
            </button>
        </div>
    );
};

QrCodePanel.propTypes = {
    url: PropTypes.string,
};

QrCodePanel.defaultProps = {
    url: "",
};

export default QrCodePanel;
